import React from 'react'
import axios from 'axios';
import utils from '../Utils';
import { Button } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import { Link } from 'react-router-dom'
import Header from 'components/Header'
import Loading from 'components/Loading'
import SnackBar from 'components/SnackBar'




import style from 'style/Article.css'

const blogURL = 'https://www.tebinja.com/api/v1/blog/posts/'
const blogimage = 'https://www.tebinja.com/img/uploads/blog/'

class ArticlePage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      blogId: this.props.match.params.id,
      article:undefined
    }
  }
  componentDidMount() {
    this.fetchArticle()
  }
  fullName = (patient) => {
    return patient.fname + ((patient.lname && patient.fname) && ' ') + patient.lname
  }
  showQuiz = (quizId) => {

  }
  blogImage = (img) => {
    return blogimage + img
  }
  fetchArticle = async () => {

    this.setState({ loading: true })
    let result = await axios.get(blogURL + this.state.blogId).catch((e) => {
      // console.log(e.response)
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.SnackBar.openSnackbar(message)
    });
    this.setState({ loading: false })

    if (!result) return
    // console.log(result, '###############')

    let { success, posts } = result.data;
    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')
    this.setState({ article: posts })


  }
  render() {
    const { article } = this.state
    return (
      <React.Fragment>
        <Header title="مقالات کرونا" showBackButton={true} ></Header>
        <div class="article-page page-root">
          <SnackBar ref={el => { this.SnackBar = el }}></SnackBar>
          {this.state.loading && <Loading></Loading>}

          {!this.state.loading && article&&
            <>
              <div class='image-section' style={{ backgroundImage: `url("${this.blogImage(article.featuredImage)}")` }}>
                {/* <img src='https://www.tebinja.com/img/uploads/blog/15470.jpeg' /> */}
              </div>
              <div class='info'>
                <div class='bold title'>{article.title}</div>

                <div class='kv-label article-desc'>
                  {article.description}

                </div>


            </div>

            <div class='body' dangerouslySetInnerHTML={{ __html:  article.body  }}>



              </div>

            </>
          }
        </div>
      </React.Fragment>
    )
  }
}
export default ArticlePage;